import createReducer from '../createReducer';

const initialState = {
    detailsHtml: null
};

const reducer = createReducer('design', initialState);

export default reducer;